import React from 'react';

const SvgPhone = (props) => (
  <svg width={'1em'} height={'1em'} viewBox="0 0 20 21" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M12.987 11.768a.67.67 0 0 0-.683.004l-1.068.636a.668.668 0 0 1-.756-.046 17.368 17.368 0 0 1-1.52-1.324c-.53-.53-1.028-1.14-1.324-1.52a.668.668 0 0 1-.045-.756l.636-1.067a.673.673 0 0 0 .003-.685L6.663 4.334a.675.675 0 0 0-.745-.314c-.283.069-.65.237-1.036.623-1.208 1.207-1.849 3.243 2.691 7.783 4.54 4.54 6.576 3.9 7.784 2.692.387-.387.554-.755.624-1.039a.672.672 0 0 0-.313-.742l-2.681-1.569z" />
    </g>
  </svg>
);

export default SvgPhone;
